import polls from "../../api/polls";
import i18n from "../../i18n";

// initial state
const state = {
    polls: [],
    selectedPatients: [],
    patientsList: [],
    searchPatient: '',
    selectedPoll: {
        id: null,
        name: null,
        nameOriginal: null,
        score: {
            id: null,
            name: null,
        },
        progression: 0,
        total_questions: 0,
        completed: false,
        patients: [],
        deleted_at: null,
    },
    question: {
        id: null,
        special_type: null,
        text: null,
        group:{
            id: null,
            name: null,
            instructions: null,
        },
        answers: []
    },
    form: {
        name: '',
        nameOriginal: '',
        score_id: '',
        patient_ids: [],
    },
    completedNextUrl: null,
    nextUrl: null,
    lastUrl: null,
}

// getters
const getters = {

}

// actions
const actions = {
    getAllPolls({ commit, rootState }) {
        polls.index(rootState.axios).then(result => {
            commit('setPolls', result.data.polls)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.GET_ALL_POLLS_LOADING_ERROR'), content: reason
            }, { root: true })
        })
    },

    getArchivedPolls({ commit, rootState }) {
        polls.archived(rootState.axios).then(result => {
            commit('setPolls', result.data.polls)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.GET_ALL_POLLS_LOADING_ERROR'), content: reason
            }, { root: true })
        })
    },

    getPollInfo({ commit, rootState, state }) {
        polls.get(state.selectedPoll.id, rootState.axios).then(result => {
            commit('setSelectedPollPatients', [])
            commit('setSelectedPoll', result.data.poll)
            commit('initPollForm')
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.GET_POLL_LOADING_ERROR'), content: reason
            }, { root: true })
        })
    },

    openPollFromNotification({commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            polls.createPollFromNotification(state.selectedPoll.id, rootState.patients.selectedPatient.id, payload.signature, payload.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.GET_POLL_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },

    getNextQuestionFromNotification({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            polls.nextQuestionFromNotification(state.nextUrl, rootState.axios).then(result => {
                commit('setQuestion', result.data.question)
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.GET_POLL_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },

    updateQuestionFromNotification({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            polls.updateFromNotification(state.nextUrl, payload, rootState.axios).then(result => {
                if (!result.data.completed) {
                    commit('setQuestion', result.data.question)
                    commit('setProgression', result.data.progression)
                } else {
                    commit('setCompleted', result.data.completed)
                    commit('setCompletedNextUrl', result.data.next_link)
                }
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_POLL_SUCCESS.title'), content: i18n.t('success.UPDATE_POLL_SUCCESS.content')
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_POLL_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },

    removeLastAnswerFromNotification({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            polls.removeLastAnswerFromNotification(state.lastUrl, rootState.axios).then(result => {
                commit('setQuestion', result.data.question)
                commit('setProgression', result.data.progression)
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_POLL_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },

    createPoll({ state, commit, rootState }) {
        polls.add(state.form, rootState.axios).then(result => {
            commit('notifications/showSuccess', i18n.t('success.CREATE_POLL_SUCCESS'), { root: true })
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.CREATE_POLL_ERROR'), content: reason
            }, { root: true })
        })
    },

    updatePoll({ state, commit, rootState }) {
        polls.update(state.selectedPoll.id, state.form, rootState.axios).then(result => {
            commit('notifications/showSuccess', i18n.t('success.UPDATE_POLL_SUCCESS'), { root: true })
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.UPDATE_POLL_ERROR'), content: reason
            }, { root: true })
        })
    },

    getCreateFormOptions({state, commit, rootState }) {
        polls.getCreateForm(rootState.axios, state.selectedPoll.id).then(result => {
            commit('surveys/setActivePunctualScores', result.data.scores, { root: true })
            commit('setPatientsList', result.data.patients)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.GET_ALL_PATIENTS_LOADING_ERROR'), content: reason
            }, { root: true })
        })
    },

    selectAllPatients({ commit, state }) {
        commit('setSelectedPatients', [...state.selectedPatients, ...state.patientsList])
        commit('setPatientsList', [])
        commit('setFormPatientIds', state.selectedPatients.map(patient => patient.id))
    },

    removeAllPatients({ commit, state }){
        commit('setPatientsList', [...state.patientsList, ...state.selectedPatients])
        commit('setSelectedPatients', [])
        commit('setFormPatientIds', [])
    },

    searchPatient({ commit, state }) {
        // hide all patients that don't match the search

        if(state.searchPatient.length === 0){
            commit('setPatientsList', state.patientsList.map(patient => {
                patient.hide = false;
                return patient
            }))
            commit('setSelectedPatients', state.selectedPatients.map(patient => {
                patient.hide = false;
                return patient
            }))
            commit('setSelectedPollPatients', state.selectedPoll.patients.map(patient => {
                patient.hide = false;
                return patient
            }))
        } else{
           commit('setPatientsList', state.patientsList.map(patient => {
               patient.hide = !patient.name.toLowerCase().includes(state.searchPatient.toLowerCase());
               return patient
           }))
          commit('setSelectedPatients', state.selectedPatients.map(patient => {
            patient.hide = !patient.name.toLowerCase().includes(state.searchPatient.toLowerCase());
            return patient
          }))
            commit('setSelectedPollPatients', state.selectedPoll.patients.map(patient => {
                patient.hide = !patient.name.toLowerCase().includes(state.searchPatient.toLowerCase());
                return patient
            }))
        }
    },

    getPollExport({ commit, rootState, state}, pollId) {
        return new Promise((resolve, reject) => {
            polls.export(pollId, rootState.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.STUDY_EXPORT_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    archivePoll({ commit, rootState, state }, pollId) {
        polls.delete(pollId, rootState.axios).then(result => {
            commit('notifications/showSuccess', i18n.t('success.ARCHIVE_POLL_SUCCESS'), { root: true })
            commit('setPolls', state.polls.filter(poll => poll.id !== pollId))
            commit('setSelectedPoll', result.data.poll)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.ARCHIVE_POLL_ERROR'), content: reason
            }, { root: true })
        })
    },
    restorePoll({ commit, rootState, state }, pollId) {
        polls.restore(pollId, rootState.axios).then(result => {
            commit('notifications/showSuccess', i18n.t('success.RESTORE_POLL_SUCCESS'), { root: true })
            commit('setPolls', state.polls.filter(poll => poll.id !== pollId))
            commit('setSelectedPoll', result.data.poll)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.RESTORE_POLL_ERROR'), content: reason
            }, { root: true })
        })
    }
}

// mutations
const mutations = {
    setPolls(state, polls) {
        state.polls = polls;
    },

    initPollForm(state) {
        state.searchPatient = '';

        if(state.selectedPoll.id){
            state.form = {
                name: state.selectedPoll.name,
                nameOriginal: state.selectedPoll.name,
                score_id: state.selectedPoll.score.id,
                patient_ids: state.selectedPoll.patients.map(patient => patient.id)
            };
        } else {
            state.form = {
                name: '',
                nameOriginal: '',
                score_id: '',
                patient_ids: [],
            };
            state.selectedPatients = [];
            state.selectedPoll.patients = [];
        }
    },

    setSelectedPollId(state, poll_id) {
        state.selectedPoll.id = poll_id;
    },

    setSelectedPoll(state, poll) {
        state.selectedPoll = poll;
    },

    setFormName(state, name) {
        state.form.name = name;
    },

    setFormScoreId(state, score_id) {
        state.form.score_id = score_id;
    },

    setFormPatientIds(state, patient_ids) {
        state.form.patient_ids = patient_ids;
    },

    setSelectedPatients(state, patients) {
        state.selectedPatients = patients;
    },

    setPatientsList(state, patients) {
        state.patientsList = patients;
    },

    setSelectedPollPatients(state, patients) {
        state.selectedPoll.patients = patients;
    },

    selectPatient(state, patient) {
        state.selectedPatients.push(patient)
        state.patientsList.splice(state.patientsList.indexOf(patient), 1)
        state.form.patient_ids.push(patient.id)
    },

    removePatient(state, patient) {
        state.patientsList.push(patient)
        if (state.selectedPoll.patients.indexOf(patient) !== -1) {
            state.selectedPoll.patients.splice(state.selectedPoll.patients.indexOf(patient), 1)
        }
        if(state.selectedPatients.indexOf(patient) !== -1) {
            state.selectedPatients.splice(state.selectedPatients.indexOf(patient), 1)
        }
        state.form.patient_ids.splice(state.form.patient_ids.indexOf(patient.id), 1)
    },

    setSearchPatientName(state, name){
        state.searchPatient = name;
    },

    setCompletedNextUrl(state, url) {
        state.completedNextUrl = url
    },

    setNextUrl(state, url) {
        state.nextUrl = url;
    },

    setLastUrl(state, url) {
        state.lastUrl = url;
    },

    setQuestion(state, question) {
        state.question = question;
    },

    setCompleted(state, completed) {
        state.selectedPoll.completed = completed;
    },

    setProgression(state, progression) {
        state.selectedPoll.progression = progression;
    },

    setTotalQuestions(state, total_questions) {
        state.selectedPoll.total_questions = total_questions;
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
